import React, { useEffect, useContext, useState } from "react";
import SetupContext from "../../context/setup";
import ThemeContext from "../../context/themeContext";
import { setCookie, setThemeOptionOnPage } from "./cookie";
const Setup = () => {
  const [data, setdata] = useState({});
  const [formload, setformload] = useState(false);
  const currentContext = useContext(SetupContext);
  const CurrenthemeContext = useContext(ThemeContext);

  useEffect(() => {
    const loadOnPage = async () => {
      const result = await setThemeOptionOnPage();
      if (result) {
        setdata(result);
        setformload(true);
      }
    };
    loadOnPage();
  }, []);

  const handleOnClick = async (name) => {
    if (name === "isopen") {
      currentContext.onChange(!currentContext.isOpen);
    } else if (name === "theme") {
      const value = data.theme_version === "dark" ? "light" : "dark";
      setdata({
        ...data,
        theme_version: value,
      });

      const result = setCookie("theme_version", value);

      if (result) {
        CurrenthemeContext.onChange({
          name: value,
          change: !CurrenthemeContext.changeTheme.change,
        });
      }
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
          <div
            className="widget-stat card"
            onClick={() => handleOnClick("isopen")}
            style={{ cursor: "pointer" }}
          >
            <div className="card-body p-4">
              <div className="media ai-icon">
                <span className="me-3 bgl-primary text-primary">
                  <i className="fas fa-align-justify" />
                </span>
                <div className="media-body text-end">
                  <div className="media-body  text-end">
                    <span className="fs-3 text-primary fw-bold">Set Theme</span>
                  </div>

                  {/* <span className="badge badge-primary fs-5 ">20</span> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
          <div
            className="widget-stat card"
            onClick={() => handleOnClick("theme")}
            style={{ cursor: "pointer" }}
          >
            <div className="card-body p-4">
              <div className="media ai-icon">
                <span className="me-3 bgl-warning text-warning">
                  <i className="fas fa-paper-plane"></i>
                </span>
                <div className="media-body  text-end">
                  <div className="media-body  text-end">
                    <span className="fs-3 text-warning fw-bold">
                      {data.theme_version === "dark"
                        ? "Light mode"
                        : "Dark mode"}{" "}
                    </span>
                  </div>

                  {/* <span className="badge badge-warning fs-5">5</span> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Setup;
